import Availability from '@/helpers/Availability'
import { isObjectEmpty } from '@/utils/main_utils'
export default {
  state: {
    selectDeliveryAreaOption: 'googleMaps',
    //customerFullAddress: '',
    // customerPosition: {
    //   address: {
    //     country_code: undefined,
    //     building: undefined,
    //     city: undefined,
    //     street: undefined,
    //     fullAddress: undefined,
    //   },
    //   coordinates: {
    //     lat: 0,
    //     lng: 0,
    //   },
    // },
    //settingAddress: false,
    selectedDa: undefined,
    selectedCity: undefined,
    selectedCheckoutStore: undefined,
  },
  mutations: {
    // START_SETTING_ADDRESS: state => (state.settingAddress = true),
    // END_SETTING_ADDRESS: state => (state.settingAddress = false),
    // SET_CURRENT_DA: (state, val) => {
    //   state.selectedDa = val
    //   localStorage.setItem('selectedDa', JSON.stringify(val))
    // },
    // SET_CUSTOMER_ADDRESS: (state, val) =>
    //   (state.customerPosition.address = val),
    // SET_CUSTOMER_FULL_ADDRESS: (state, val) =>
    //   (state.customerFullAddress = val),
    // RESET_ADDRESS: state => {
    //   state.selectedDa = []
    //   localStorage.setItem('selectedDa', JSON.stringify([]))
    //   state.customerFullAddress = ''
    //   state.customerPosition = {
    //     address: {
    //       country_code: undefined,
    //       building: undefined,
    //       city: undefined,
    //       street: undefined,
    //     },
    //     coordinates: {
    //       lat: 0,
    //       lng: 0,
    //     },
    //   }
    // },
    // SET_CUSTOMER_COORDINATES: (state, new_val) => {
    //   Vue.set(state.customerPosition.coordinates, 'lat', new_val.lat)
    //   Vue.set(state.customerPosition.coordinates, 'lng', new_val.lng)
    // },
    // SET_SELECT_DELIVERY_AREA_OPTION: (state, val) => {
    //   state.selectDeliveryAreaOption = val
    // },
    SET_SELECTED_DA: (state, val) => {
      state.selectedDa = val
    },
    SET_SELECTED_CITY: (state, val) => {
      state.selectedCity = val
    },
    SET_SELECTED_CHECKOUT_STORE: (state, val) =>
      (state.selectedCheckoutStore = val),
  },
  actions: {},
  getters: {
    // here we have delivery Area: without city and country code: like 'Abu hail' only
    selectedDa: state => state.selectedDa,
    customerPosition: state => state.customerPosition,
    customerCoordinates: state => state.customerPosition.coordinates,
    isSettingAddress: state => state.settingAddress,
    customerFullAddress: state => state.customerFullAddress,
    selectedDeliveryAreaOption: state => state.selectDeliveryAreaOption,

    // eslint-disable-next-line no-unused-vars
    getElementByAreaId: state => (deliveryArea, element) => {
      let deliveryAreaArr = deliveryArea.code
        ? deliveryArea.code.split('|')
        : []
      return deliveryAreaArr[deliveryAreaArr.length - element]
    },
    selectedCheckoutStore: state => state.selectedCheckoutStore,
    //delivery area id should be based on what city user selected
    selectedDaId: (state, getters) => {
      if (getters.customer_address) {
        // here we have delivery Area id: like Abu Hail|Dubai|AE
        return getters.customer_address.delivery_area_id
      } else if (getters.selectedDa && getters.locationCity) {
        // here selectedDa will br only Abu Hail
        return (
          getters.selectedDa +
          '|' +
          getters.locationCity +
          '|' +
          getters.selectedCountry
        )
      }
    },
    selectedTimezone: (state, getters) =>
      state.selectedTimezone || getters.userLocation.timezone,
    currentStoreId: (state, getters) => {
      let currentStoreId = getters.currentStore
        ? getters.currentStore._id
        : undefined
      if (!currentStoreId) {
        // added this section because in order tracking page store id undefined
        currentStoreId = getters.storeIdURL
      }
      return currentStoreId
    },
    storesInCurrentDa: (state, getters) => {
      if (!getters.selectedDaId) {
        return []
      }
      //stores do not contain the delivery area, so we need to first get all brand delivery areas
      //and then match those delivery areas with current delivery area
      //if there are 3 stores serving in same da, we ll get 3 entries in filter below with same da but
      //different store ids
      const delivery_areas = getters.all_delivery_areas.filter(
        storeDa => storeDa.delivery_area == getters.selectedDaId
      )

      if (!delivery_areas.length) {
        return []
      }
      //getters.all_stores always returns stores
      //if in brand context then it ll return brand stores
      //otherwise it ll return all stores i.e goorder stores
      return getters.all_stores.filter(store =>
        delivery_areas.some(da => da.store_id == store._id)
      )
    },
    currentStore: (state, getters) => {
      if (getters.isFloorTableAvailable.table_id) {
        return getters.getStoreByURL
      }
      //this getters returns whole store object not id
      if (getters.selectedCheckoutStore) {
        return getters.selectedCheckoutStore
      }
      if (getters.availableStores) {
        //get those stores which exist in user selected city
        const store = getters.availableStores.find(
          store => store.city == getters.locationCity
        )
        if (store) {
          return store
        }
        return getters.availableStores[0]
      }
      return undefined
      //TODO: use in future getters.cart_based_store
      //3. if there are more than one stores avialable in current delivery area
      // - check if there are items in cart
      //-- if there are items in cart then select store which has more available items
      //-- if there are no items in cart then select first store available
    },
    locationCity: (state, getters) => {
      if (
        getters.customer_address &&
        getters.customer_address.delivery_area_id
      ) {
        return getters.customer_address.delivery_area_id.split('|')[1]
      }

      if (state.selectedCity) {
        return state.selectedCity
      }

      return undefined
    },
    storeCity: (state, getters) => {
      if (getters.currentStore) {
        return getters.currentStore.city
      }
    },
    priceCity: (state, getters) => {
      if (getters.storeCity) {
        return getters.storeCity
      }
      if (getters.locationCity) {
        return getters.locationCity
      }
      if (
        getters.userLocation &&
        getters.userLocation.country == getters.selectedCountry
      ) {
        return getters.userLocation.city
      }
    },

    availableStores: (state, getters) => {
      //Note: no one can access store directly, store is not fixed, it ll be picked up based on the
      // the current location and availablity of items
      //1. get current delviery area
      // - if no delivery area present then no store is selected.

      if (!getters.selectedDa && !getters.customer_address) {
        return undefined
      }

      //if nothing in cart then no need to have store, let it reset
      // TODO: Will add store id to order
      // if (!getters.cart_items_count) {
      //   return undefined
      // }

      //2. get those stores which are available in selected delivery area in current Brand
      return getters.storesInCurrentDa
    },
    cart_based_store: (state, getters) => {
      //this getter should be only called when there are more than one store
      //and we need to choose one store based on items availablitiy
      const cartItems = getters.cart_items
      const currentDaStores = Object.freeze([...getters.storesInCurrentDa])

      let storeItems = {}
      currentDaStores.forEach(store => {
        cartItems.forEach(item => {
          if (Availability.availableInStore(item, store)) {
            if (!storeItems[store._id]) {
              storeItems[store._id] = []
            }

            storeItems[store._id].push(item._id)
          }
        })
      })

      if (isObjectEmpty(storeItems)) {
        return undefined
      }

      const stores = getters.storesInCurrentDa
      return stores[0]
    },
    available_cart_items: (state, getters) => {
      let items = getters.cart_items
      if (getters.currentStoreId) {
        items = getters.cart_items.map(item => {
          item.store_id = getters.currentStoreId
          return item
        })
      }
      return items
        .filter(item => getters.availableByLocation(item))
        .filter(item => {
          if (!item.modifiers) {
            return item
          }
          if (
            item.modifiers.some(
              modifier => !getters.availableByLocation(modifier)
            )
          ) {
            return false
          }
          return item
        })
    },
    unavailable_cart_items: (state, getters) => {
      return getters.cart_items.filter(
        item =>
          !getters.available_cart_items.find(aItem => aItem._id == item._id)
      )
    },
  },
}
